import type { FullTranslation } from "../../lib/i18n"

export const CRM_T = {
  // --- page ---------------------------------------------------------------
  breadcrumb: { FR: "CRM", EN: "CRM" },
  title: { FR: "CRM", EN: "CRM" },
  subtitle: {
    FR: "Toutes vos entreprises, de toutes vos campagnes, au même endroit.",
    EN: "Every company from every campaign, in one place.",
  },
  tabAccounts: { FR: "Entreprises", EN: "Companies" },
  tabTasks: { FR: "Mes tâches", EN: "My tasks" },
  tabDuplicates: { FR: "Doublons", EN: "Duplicates" },
  tabSettings: { FR: "Réglages", EN: "Settings" },
  noTeam: {
    FR: "Sélectionnez une équipe pour ouvrir le CRM.",
    EN: "Pick a team to open the CRM.",
  },
  failedToLoad: { FR: "Chargement impossible.", EN: "Could not load." },
  reloadThePage: { FR: "Rechargez la page.", EN: "Reload the page." },
  cancel: { FR: "Annuler", EN: "Cancel" },
  close: { FR: "Fermer", EN: "Close" },
  save: { FR: "Enregistrer", EN: "Save" },
  previous: { FR: "Précédent", EN: "Previous" },
  next: { FR: "Suivant", EN: "Next" },
  pageOf: { FR: "Page {page} sur {total}", EN: "Page {page} of {total}" },

  // --- companies list -----------------------------------------------------
  searchPlaceholder: {
    FR: "Nom, site, email, téléphone",
    EN: "Name, site, email, phone",
  },
  allCampaigns: { FR: "Toutes les campagnes", EN: "All campaigns" },
  ownerAll: { FR: "Tous les suivis", EN: "Everyone's" },
  ownerMe: { FR: "Suivies par moi", EN: "Mine" },
  ownerNone: { FR: "Sans responsable", EN: "Nobody's" },
  overdueOnly: { FR: "En retard", EN: "Overdue" },
  resetFilters: { FR: "Réinitialiser", EN: "Reset" },
  countOne: { FR: "{n} entreprise", EN: "{n} company" },
  countMany: { FR: "{n} entreprises", EN: "{n} companies" },
  colCompany: { FR: "Entreprise", EN: "Company" },
  colCategory: { FR: "Statut", EN: "Status" },
  colNextStep: { FR: "Prochaine étape", EN: "Next step" },
  colOwner: { FR: "Assigné à", EN: "Assigned to" },
  colCampaigns: { FR: "Campagnes", EN: "Campaigns" },
  colActivity: { FR: "Dernière activité", EN: "Last activity" },
  noNextStep: { FR: "Rien de prévu", EN: "Nothing planned" },
  unowned: { FR: "Libre", EN: "Free" },
  overdueCount: { FR: "{n} en retard", EN: "{n} overdue" },
  never: { FR: "Jamais", EN: "Never" },
  empty: {
    FR: "Aucune entreprise pour l'instant. Vos campagnes les ajouteront ici au fil des livraisons.",
    EN: "No companies yet. Your campaigns will add them here as leads are delivered.",
  },
  emptyFiltered: {
    FR: "Aucune entreprise ne correspond à ces filtres.",
    EN: "No company matches these filters.",
  },
  sourceCrm: { FR: "Tâche", EN: "Task" },
  sourceStep: { FR: "Séquence", EN: "Sequence" },
  sourceNote: { FR: "Rappel", EN: "Reminder" },
  contactsCountOne: { FR: "{n} contact", EN: "{n} contact" },
  contactsCountMany: { FR: "{n} contacts", EN: "{n} contacts" },

  // --- company sheet ------------------------------------------------------
  renameAction: { FR: "Renommer", EN: "Rename" },
  nameLabel: { FR: "Nom de l'entreprise", EN: "Company name" },
  renamedToast: { FR: "Nom mis à jour.", EN: "Name updated." },
  entryStatus: { FR: "{from} → {to}", EN: "{from} → {to}" },
  entryStatusByProvider: {
    FR: "Détecté par l'outil d'envoi",
    EN: "Reported by the mailing tool",
  },
  entryStatusBySequence: { FR: "Automatique", EN: "Automatic" },
  ownedBy: { FR: "Assignée à {name}", EN: "Assigned to {name}" },
  ownedByMe: { FR: "Assignée à vous", EN: "Assigned to you" },
  nobodyOwns: {
    FR: "Assignée à personne",
    EN: "Not assigned",
  },
  claimedToast: {
    FR: "Entreprise assignée à vous.",
    EN: "Company assigned to you.",
  },
  ownerChangedToast: {
    FR: "Assignation mise à jour.",
    EN: "Assignment updated.",
  },
  ownerPickerLabel: {
    FR: "Changer à qui l'entreprise est assignée",
    EN: "Change who this company is assigned to",
  },
  registry: { FR: "SIREN", EN: "Company no." },
  tabLog: { FR: "Journal", EN: "Log" },
  tabCompanyTasks: { FR: "Tâches", EN: "Tasks" },
  tabCampaignsCount: { FR: "Campagnes ({n})", EN: "Campaigns ({n})" },
  accountMerged: {
    FR: "Cette entreprise a été fusionnée dans une autre.",
    EN: "This company was merged into another one.",
  },
  openMerged: { FR: "Ouvrir l'entreprise", EN: "Open the company" },
  mergeAction: { FR: "Fusionner…", EN: "Merge…" },
  mergeTitle: {
    FR: "Fusionner avec une autre entreprise",
    EN: "Merge with another company",
  },
  mergeHint: {
    FR: "L'entreprise choisie rejoint celle-ci : ses campagnes, son journal et ses tâches. Annulable à tout moment.",
    EN: "The chosen company joins this one: its campaigns, log and tasks. You can undo it at any time.",
  },
  mergeSearch: { FR: "Chercher une entreprise", EN: "Search a company" },
  mergeNoResult: { FR: "Aucune entreprise trouvée.", EN: "No company found." },
  mergeConfirm: { FR: "Fusionner", EN: "Merge" },
  mergedToast: { FR: "Entreprises fusionnées.", EN: "Companies merged." },
  mergesTitle: { FR: "Fusions", EN: "Merges" },
  mergedFrom: { FR: "« {name} » fusionnée", EN: "“{name}” merged" },
  unmerge: { FR: "Défaire", EN: "Undo" },
  unmergedToast: { FR: "Fusion annulée.", EN: "Merge undone." },
  campaignId: { FR: "#{id}", EN: "#{id}" },
  primaryCopy: { FR: "Campagne principale", EN: "Main campaign" },
  primaryCopyHint: {
    FR: "C'est cette campagne qui contacte l'entreprise.",
    EN: "This campaign is the one contacting the company.",
  },
  pausedCopy: {
    FR: "En pause : suivie dans « {campaign} »",
    EN: "Paused: worked in \u201c{campaign}\u201d",
  },
  makePrimary: {
    FR: "Piloter depuis cette campagne",
    EN: "Drive from this campaign",
  },
  primaryChangedToast: {
    FR: "Cette campagne pilote maintenant l'entreprise.",
    EN: "This campaign now drives the company.",
  },
  pausedChip: { FR: "en pause", EN: "paused" },
  settingsSequences: { FR: "Séquences", EN: "Sequences" },
  settingsSequencesHint: {
    FR: "Une entreprise trouvée par plusieurs campagnes n'est contactée que par l'une d'elles : les autres copies sont mises en pause, jamais disqualifiées.",
    EN: "A company found by several campaigns is contacted by one of them only: the other copies are paused, never disqualified.",
  },
  perOfferLabel: { FR: "Une séquence par offre", EN: "One sequence per offer" },
  perOfferHint: {
    FR: "Si les campagnes vendent des produits différents, chacun garde sa propre séquence.",
    EN: "When campaigns sell different products, each keeps its own sequence.",
  },
  campaignOpenBoard: {
    FR: "Ouvrir le CRM de la campagne",
    EN: "Open the campaign CRM",
  },

  // --- activity log -------------------------------------------------------
  logTitle: { FR: "Journaliser", EN: "Log an activity" },
  activityTypePlaceholder: { FR: "Que s'est-il passé ?", EN: "What happened?" },
  bodyPlaceholder: { FR: "Détails, compte rendu…", EN: "Details, notes…" },
  occurredAt: { FR: "Quand", EN: "When" },
  now: { FR: "Maintenant", EN: "Now" },
  contactLabel: { FR: "Contact", EN: "Contact" },
  wholeCompany: { FR: "Toute l'entreprise", EN: "The whole company" },
  campaignLabel: { FR: "Campagne", EN: "Campaign" },
  noCampaign: { FR: "Aucune", EN: "None" },
  submitLog: { FR: "Enregistrer", EN: "Save" },
  loggedToast: { FR: "Activité enregistrée.", EN: "Activity logged." },
  followupsCreatedOne: {
    FR: "1 tâche de suivi créée.",
    EN: "1 follow-up task created.",
  },
  followupsCreatedMany: {
    FR: "{n} tâches de suivi créées.",
    EN: "{n} follow-up tasks created.",
  },
  followupTaskHint: {
    FR: "Crée ensuite la tâche « {task} »",
    EN: "Then creates the “{task}” task",
  },
  followupPlaybookHint: {
    FR: "Lance ensuite « {playbook} »",
    EN: "Then launches “{playbook}”",
  },
  requiredField: { FR: "Champ obligatoire.", EN: "Required." },
  invalidUrl: {
    FR: "Un lien http(s) est attendu.",
    EN: "An http(s) link is expected.",
  },
  invalidNumber: { FR: "Un nombre est attendu.", EN: "A number is expected." },
  selectOption: { FR: "Choisir…", EN: "Choose…" },
  urlPlaceholder: { FR: "https://", EN: "https://" },
  pickMember: { FR: "Choisir un membre", EN: "Pick a member" },
  pickDate: { FR: "Choisir une date", EN: "Pick a date" },
  datePlaceholder: {
    FR: "demain, vendredi, 12 mars…",
    EN: "tomorrow, friday, march 12…",
  },
  timelineEmpty: {
    FR: "Rien d'enregistré pour l'instant.",
    EN: "Nothing logged yet.",
  },
  loadMore: { FR: "Voir plus", EN: "Load more" },
  entryNote: { FR: "Note de campagne", EN: "Campaign note" },
  entryStepDone: { FR: "Étape faite", EN: "Step done" },
  entryStepSkipped: { FR: "Étape ignorée", EN: "Step skipped" },
  entryTaskDone: { FR: "Tâche terminée", EN: "Task done" },
  entryTaskCancelled: { FR: "Tâche annulée", EN: "Task cancelled" },
  entryBy: { FR: "par {name}", EN: "by {name}" },
  entryReminderDue: { FR: "rappel le {when}", EN: "reminder on {when}" },
  deleteEntry: { FR: "Supprimer l'entrée", EN: "Delete entry" },
  meetingTranscript: { FR: "Voir la transcription", EN: "View transcript" },
  meetingTranscriptEmpty: {
    FR: "Aucune transcription pour cette réunion.",
    EN: "No transcript for this meeting.",
  },
  // Meetings from the note-taking tool that matched no company.
  pendingMeetingsChip: {
    FR: "Réunion à rattacher",
    EN: "Meeting to file",
  },
  pendingMeetingsHint: {
    FR: "Réunions enregistrées où aucun participant n'a été reconnu. Rattachez celle qui concerne cette entreprise : son compte rendu et sa transcription rejoignent le journal.",
    EN: "Recorded meetings where no attendee was recognized. File the one about this company: its report and transcript join the journal.",
  },
  pendingMeetingsEmpty: {
    FR: "Aucune réunion en attente.",
    EN: "No meeting waiting.",
  },
  pendingMeetingsFailed: {
    FR: "Impossible de charger les réunions.",
    EN: "Failed to load meetings.",
  },
  meetingFileHere: { FR: "Rattacher ici", EN: "File here" },
  meetingDismiss: { FR: "Ignorer", EN: "Ignore" },
  meetingOpenIn: { FR: "Ouvrir dans {tool}", EN: "Open in {tool}" },
  meetingNoRecording: {
    FR: "Pas d'enregistrement vidéo",
    EN: "No video recording",
  },
  meetingDismissHint: {
    FR: "Réunion interne ou sans client : ne plus la proposer",
    EN: "Internal meeting or no client: stop offering it",
  },
  meetingDismissedToast: {
    FR: "Réunion ignorée : elle ne sera plus proposée.",
    EN: "Meeting ignored: it won't be offered again.",
  },
  meetingUndo: { FR: "Annuler", EN: "Undo" },
  meetingDismissTitle: {
    FR: "Ignorer cette réunion ?",
    EN: "Ignore this meeting?",
  },
  meetingDismissBody: {
    FR: "« {title} » ne sera plus proposée dans les réunions à rattacher. À utiliser pour une réunion interne ou qui ne concerne aucun client.",
    EN: '"{title}" will no longer be offered among the meetings to file. Use it for an internal meeting or one that concerns no client.',
  },
  meetingRestoredToast: {
    FR: "La réunion est de nouveau proposée.",
    EN: "The meeting is offered again.",
  },
  meetingPreview: { FR: "Aperçu", EN: "Preview" },
  meetingSummary: { FR: "Compte rendu", EN: "Report" },
  meetingTranscriptHeading: { FR: "Transcription", EN: "Transcript" },
  meetingSearchPlaceholder: {
    FR: "Rechercher par titre ou participant",
    EN: "Search by title or attendee",
  },
  meetingSearchEmpty: {
    FR: "Aucune réunion ne correspond à cette recherche.",
    EN: "No meeting matches this search.",
  },
  meetingFiledToast: { FR: "Réunion rattachée", EN: "Meeting filed" },
  meetingUntitled: { FR: "Réunion sans titre", EN: "Untitled meeting" },
  meetingNoAttendee: { FR: "Aucun participant", EN: "No attendee" },
  meetingOpenRecording: {
    FR: "Ouvrir la réunion",
    EN: "Open the meeting",
  },
  deleteEntryTitle: {
    FR: "Supprimer cette entrée ?",
    EN: "Delete this entry?",
  },
  deleteEntryBody: {
    FR: "Une entrée ne se modifie pas : la supprimer est la seule correction possible.",
    EN: "Entries are never edited: deleting is the only correction.",
  },
  confirmDelete: { FR: "Supprimer", EN: "Delete" },
  deletedToast: { FR: "Supprimé.", EN: "Deleted." },

  // --- tasks --------------------------------------------------------------
  newTask: { FR: "Nouvelle tâche", EN: "New task" },
  newChain: { FR: "Enchaînement", EN: "Chain" },
  launchPlaybook: { FR: "Lancer un playbook", EN: "Launch a playbook" },
  tasksEmpty: {
    FR: "Aucune tâche sur cette entreprise.",
    EN: "No task on this company.",
  },
  statusBlocked: { FR: "En attente", EN: "Waiting" },
  statusOpen: { FR: "À faire", EN: "To do" },
  statusDone: { FR: "Faite", EN: "Done" },
  statusCancelled: { FR: "Annulée", EN: "Cancelled" },
  waitingOnPrevious: {
    FR: "Démarre après l'étape précédente",
    EN: "Starts after the previous step",
  },
  chainStep: { FR: "Étape {n}/{total}", EN: "Step {n}/{total}" },
  complete: { FR: "Terminer", EN: "Done" },
  cancelTask: { FR: "Annuler la tâche", EN: "Cancel task" },
  skipChainStep: { FR: "Passer cette étape", EN: "Skip this step" },
  reopen: { FR: "Rouvrir", EN: "Reopen" },
  cancelChain: { FR: "Annuler l'enchaînement", EN: "Cancel the chain" },
  cancelChainTitle: {
    FR: "Annuler tout l'enchaînement ?",
    EN: "Cancel the whole chain?",
  },
  cancelChainBody: {
    FR: "Toutes les étapes encore à faire seront annulées. Les étapes déjà faites restent.",
    EN: "Every step still to do is cancelled. Steps already done stay.",
  },
  saveAsPlaybook: { FR: "Enregistrer comme playbook", EN: "Save as playbook" },
  playbookName: { FR: "Nom du playbook", EN: "Playbook name" },
  savedPlaybookToast: { FR: "Playbook enregistré.", EN: "Playbook saved." },
  assignee: { FR: "Assignée à", EN: "Assigned to" },
  unassigned: { FR: "Non assignée", EN: "Unassigned" },
  assignToMe: { FR: "Me l'assigner", EN: "Assign to me" },
  reschedule: { FR: "Replanifier", EN: "Reschedule" },
  rescheduledToast: { FR: "Échéance modifiée.", EN: "Due date changed." },
  closedTasks: { FR: "Terminées", EN: "Closed" },
  campaignWorkTitle: { FR: "Dans les campagnes", EN: "From the campaigns" },
  doneToast: { FR: "Tâche terminée.", EN: "Task done." },
  cancelledToast: { FR: "Tâche annulée.", EN: "Task cancelled." },
  reopenedToast: { FR: "Tâche rouverte.", EN: "Task reopened." },
  assignedToast: { FR: "Tâche réassignée.", EN: "Task reassigned." },

  // --- task / chain dialog ---------------------------------------------------
  dialogNewTask: { FR: "Nouvelle tâche", EN: "New task" },
  dialogNewChain: { FR: "Nouvel enchaînement", EN: "New chain" },
  dialogChainHint: {
    FR: "Des tâches liées : chacune démarre quand la précédente est faite (ou à date fixe après son échéance).",
    EN: "Linked tasks: each starts once the previous one is done (or a fixed time after its due date).",
  },
  taskType: { FR: "Type", EN: "Type" },
  taskTitle: { FR: "Titre", EN: "Title" },
  taskTitlePlaceholder: {
    FR: "Titre (par défaut : le type)",
    EN: "Title (defaults to the type)",
  },
  taskDescription: { FR: "Détails", EN: "Details" },
  firstDue: { FR: "Échéance", EN: "Due" },
  addStep: { FR: "Ajouter une étape", EN: "Add a step" },
  insertStep: { FR: "Insérer une étape", EN: "Insert a step" },
  pickTaskType: { FR: "Choisir un type", EN: "Pick a type" },
  noTaskTypeMatch: { FR: "Aucun type trouvé.", EN: "No matching type." },
  flowStart: { FR: "Lancement du playbook", EN: "Playbook launch" },
  flowStartOn: { FR: "Début le {date}", EN: "Starts on {date}" },
  flowEnd: { FR: "Fin", EN: "End" },
  immediate: { FR: "Immédiat", EN: "Right away" },
  waitFor: { FR: "Attendre", EN: "Wait" },
  removeStep: { FR: "Retirer l'étape", EN: "Remove step" },
  stepN: { FR: "Étape {n}", EN: "Step {n}" },
  delayDays: { FR: "jours", EN: "days" },
  afterLaunch: { FR: "après le lancement", EN: "after launch" },
  dayPlus: { FR: "J+{n}", EN: "D+{n}" },
  anchorAfterDone: {
    FR: "après que la précédente est faite",
    EN: "after the previous one is done",
  },
  anchorAfterDue: {
    FR: "après l'échéance de la précédente",
    EN: "after the previous one's due date",
  },
  assigneeAuto: { FR: "Automatique", EN: "Automatic" },
  assigneeAutoHint: {
    FR: "La personne assignée à l'entreprise, sinon les règles d'attribution.",
    EN: "Whoever the company is assigned to, otherwise the assignment rules.",
  },
  createTask: { FR: "Créer la tâche", EN: "Create task" },
  createChain: { FR: "Créer l'enchaînement", EN: "Create chain" },
  createdTaskToast: { FR: "Tâche créée.", EN: "Task created." },
  createdChainToast: { FR: "Enchaînement créé.", EN: "Chain created." },
  schedulePreview: { FR: "Calendrier prévu", EN: "Planned schedule" },
  previewOn: { FR: "le {date}", EN: "on {date}" },
  previewAfterDone: {
    FR: "{n} j après la précédente",
    EN: "{n} d after the previous one",
  },
  noTaskTypes: {
    FR: "Créez d'abord un type de tâche dans Réglages.",
    EN: "Create a task type in Settings first.",
  },
  launchTitle: { FR: "Lancer un playbook", EN: "Launch a playbook" },
  launchFrom: { FR: "À partir du", EN: "Starting on" },
  launch: { FR: "Lancer", EN: "Launch" },
  launchedToast: { FR: "Playbook lancé.", EN: "Playbook launched." },
  noPlaybooksYet: {
    FR: "Aucun playbook pour l'instant.",
    EN: "No playbook yet.",
  },
  noPlaybooks: {
    FR: "Aucun playbook. Créez-en un dans Réglages, ou enregistrez un enchaînement.",
    EN: "No playbook yet. Create one in Settings, or save a chain.",
  },
  stepsCountOne: { FR: "1 étape", EN: "1 step" },
  stepsCountMany: { FR: "{n} étapes", EN: "{n} steps" },

  // --- my tasks -----------------------------------------------------------
  scopeMine: { FR: "Moi", EN: "Me" },
  scopePool: { FR: "Non assignées", EN: "Unassigned" },
  scopeTeam: { FR: "Équipe", EN: "Team" },
  stateOpen: { FR: "À faire", EN: "To do" },
  stateDone: { FR: "Faites", EN: "Done" },
  searchTasks: {
    FR: "Rechercher une tâche, une entreprise",
    EN: "Search a task, a company",
  },
  tasksEmptyMine: {
    FR: "Rien à faire pour vous. Les tâches qui vous sont assignées apparaîtront ici.",
    EN: "Nothing for you to do. Tasks assigned to you will show up here.",
  },
  tasksEmptyPool: {
    FR: "Aucune tâche sans responsable.",
    EN: "No unassigned task.",
  },
  tasksEmptyTeam: {
    FR: "L'équipe n'a rien en attente.",
    EN: "The team has nothing pending.",
  },
  tasksEmptyDone: {
    FR: "Rien de terminé récemment.",
    EN: "Nothing finished recently.",
  },
  colDue: { FR: "Échéance", EN: "Due" },
  colWhat: { FR: "À faire", EN: "What" },
  colAssignee: { FR: "Assignée à", EN: "Assignee" },
  noDeadline: { FR: "Sans date", EN: "No date" },
  markDone: { FR: "Marquer comme fait", EN: "Mark as done" },
  skipStep: { FR: "Ignorer l'étape", EN: "Skip the step" },
  inviteAccepted: { FR: "Invitation acceptée", EN: "Invite accepted" },
  invitePending: { FR: "Toujours en attente", EN: "Still pending" },
  checkInvite: { FR: "Répondre", EN: "Answer" },
  openLinkedinProfile: {
    FR: "Ouvrir le profil LinkedIn",
    EN: "Open the LinkedIn profile",
  },
  callNumber: { FR: "Appeler le {phone}", EN: "Call {phone}" },
  openCompany: { FR: "Ouvrir l'entreprise", EN: "Open the company" },
  overdueByDays: { FR: "{n} j de retard", EN: "{n} d late" },
  doneBy: { FR: "Faite par {name}", EN: "Done by {name}" },

  // --- duplicates ---------------------------------------------------------
  duplicatesIntro: {
    FR: "Ces fiches désignent peut-être la même entreprise. Rien n'est fusionné sans votre accord, et une fusion se défait.",
    EN: "These records may be the same company. Nothing is merged without you, and a merge can be undone.",
  },
  verdictHigh: {
    FR: "Très probablement la même entreprise",
    EN: "Very likely the same company",
  },
  verdictMedium: {
    FR: "Probablement la même entreprise",
    EN: "Probably the same company",
  },
  verdictLow: {
    FR: "Peut-être la même entreprise",
    EN: "Possibly the same company",
  },
  likeness: {
    FR: "Doublon probable à {n} %",
    EN: "{n}% likely to be a duplicate",
  },
  evidenceRegistry: { FR: "Même SIREN : {v}", EN: "Same company number: {v}" },
  evidenceEmail: { FR: "Email en commun : {v}", EN: "Shared email: {v}" },
  evidencePhone: { FR: "Téléphone en commun : {v}", EN: "Shared phone: {v}" },
  evidenceDomain: { FR: "Même site : {v}", EN: "Same website: {v}" },
  evidenceSameName: {
    FR: "Même nom à {city}",
    EN: "Same name in {city}",
  },
  evidenceSimilarName: {
    FR: "Nom très proche à {city}",
    EN: "Near-identical name in {city}",
  },
  foundTogether: {
    FR: "Trouvées toutes deux par « {campaign} »",
    EN: "Both found by “{campaign}”",
  },
  campaignOf: { FR: "campagne du {date}", EN: "campaign of {date}" },
  foundOn: { FR: "trouvée le {date}", EN: "found on {date}" },
  inCommon: { FR: "en commun", EN: "shared" },
  keepThisRecord: { FR: "Garder cette fiche", EN: "Keep this record" },
  openRecord: { FR: "Voir la fiche", EN: "View record" },
  showAll: { FR: "Voir tout ({n} de plus)", EN: "Show all ({n} more)" },
  showLess: { FR: "Voir moins", EN: "Show less" },
  showMore: { FR: "Voir plus", EN: "Show more" },
  mergeEffect: {
    FR: "« {name} » est gardée : l'autre fiche y est rattachée avec ses campagnes, tâches et notes.",
    EN: "“{name}” is kept: the other record joins it with its campaigns, tasks and notes.",
  },
  notDuplicate: { FR: "Pas un doublon", EN: "Not a duplicate" },
  dismissedToast: { FR: "Suggestion écartée.", EN: "Suggestion dismissed." },
  duplicatesEmpty: {
    FR: "Aucun doublon probable.",
    EN: "No likely duplicate.",
  },

  // --- settings -----------------------------------------------------------
  settingsActivityTypes: { FR: "Types d'activité", EN: "Activity types" },
  settingsActivityTypesHint: {
    FR: "Ce que votre équipe journalise, avec le formulaire de chaque entrée et la suite à donner.",
    EN: "What your team logs, the form each entry asks for, and what follows.",
  },
  settingsTaskTypes: { FR: "Types de tâche", EN: "Task types" },
  settingsTaskTypesHint: {
    FR: "Le travail que vous vous répartissez. Les règles d'attribution s'appuient dessus.",
    EN: "The work you share out. Assignment rules match on it.",
  },
  settingsPlaybooks: { FR: "Playbooks", EN: "Playbooks" },
  settingsPlaybooksHint: {
    FR: "Des enchaînements de tâches réutilisables, à lancer sur n'importe quelle entreprise.",
    EN: "Reusable chains of tasks, to launch on any company.",
  },
  settingsRules: { FR: "Règles d'attribution", EN: "Assignment rules" },
  settingsRulesHint: {
    FR: "Qui reçoit une tâche que personne n'a assignée. La personne assignée à l'entreprise passe d'abord, sauf règle prioritaire. La première règle qui correspond l'emporte.",
    EN: "Who gets a task nobody assigned. Whoever the company is assigned to comes first unless a rule overrides it. The first matching rule wins.",
  },
  rulesAdminOnly: {
    FR: "Seuls les propriétaires et administrateurs de l'équipe peuvent modifier les règles.",
    EN: "Only the team's owners and admins can change the rules.",
  },
  add: { FR: "Ajouter", EN: "Add" },
  edit: { FR: "Modifier", EN: "Edit" },
  archive: { FR: "Archiver", EN: "Archive" },
  restore: { FR: "Réactiver", EN: "Restore" },
  archivedBadge: { FR: "Archivé", EN: "Archived" },
  delete: { FR: "Supprimer", EN: "Delete" },
  savedToast: { FR: "Enregistré.", EN: "Saved." },
  archivedToast: {
    FR: "Archivé : il est déjà utilisé.",
    EN: "Archived: it is already in use.",
  },
  removedToast: { FR: "Supprimé.", EN: "Removed." },
  moveUp: { FR: "Monter", EN: "Move up" },
  moveDown: { FR: "Descendre", EN: "Move down" },
  showArchived: { FR: "Afficher les archivés", EN: "Show archived" },
  iconPhone: { FR: "Téléphone", EN: "Phone" },
  iconPhoneIncoming: { FR: "Appel reçu", EN: "Incoming call" },
  iconVideo: { FR: "Vidéo", EN: "Video" },
  iconMail: { FR: "Email", EN: "Email" },
  iconLinkedin: { FR: "LinkedIn", EN: "LinkedIn" },
  iconNote: { FR: "Note", EN: "Note" },
  iconFileText: { FR: "Document", EN: "Document" },
  iconReceipt: { FR: "Devis", EN: "Quote" },
  iconGithub: { FR: "GitHub", EN: "GitHub" },
  iconLightbulb: { FR: "Idée", EN: "Idea" },
  iconCalendar: { FR: "Agenda", EN: "Calendar" },
  iconRepeat: { FR: "Relance", EN: "Follow-up" },
  iconHandshake: { FR: "Accord", EN: "Deal" },
  iconStar: { FR: "Étoile", EN: "Star" },
  iconFlag: { FR: "Drapeau", EN: "Flag" },
  iconMessage: { FR: "Message", EN: "Message" },
  colorNeutral: { FR: "Neutre", EN: "Neutral" },
  colorBlue: { FR: "Bleu", EN: "Blue" },
  colorGreen: { FR: "Vert", EN: "Green" },
  colorAmber: { FR: "Ambre", EN: "Amber" },
  colorRed: { FR: "Rouge", EN: "Red" },
  colorViolet: { FR: "Violet", EN: "Violet" },
  labelField: { FR: "Libellé", EN: "Label" },
  iconField: { FR: "Icône", EN: "Icon" },
  colorField: { FR: "Couleur", EN: "Color" },
  defaultDelay: {
    FR: "Échéance proposée (jours)",
    EN: "Suggested due date (days)",
  },
  fieldsTitle: { FR: "Champs du formulaire", EN: "Form fields" },
  fieldsHint: {
    FR: "Ce que l'équipe renseigne en journalisant ce type (un lien GitHub, une date de devis…).",
    EN: "What the team fills in when logging this type (a GitHub link, a quote date…).",
  },
  addField: { FR: "Ajouter un champ", EN: "Add a field" },
  fieldLabel: { FR: "Nom du champ", EN: "Field name" },
  fieldType: { FR: "Type", EN: "Type" },
  fieldRequired: { FR: "Obligatoire", EN: "Required" },
  fieldOptions: { FR: "Options (une par ligne)", EN: "Options (one per line)" },
  removeField: { FR: "Retirer le champ", EN: "Remove field" },
  fieldTypeText: { FR: "Texte court", EN: "Short text" },
  fieldTypeLongtext: { FR: "Texte long", EN: "Long text" },
  fieldTypeUrl: { FR: "Lien", EN: "Link" },
  fieldTypeDate: { FR: "Date", EN: "Date" },
  fieldTypeDatetime: { FR: "Date et heure", EN: "Date and time" },
  fieldTypeNumber: { FR: "Nombre", EN: "Number" },
  fieldTypeSelect: { FR: "Liste de choix", EN: "Choice list" },
  fieldTypeUser: { FR: "Membre de l'équipe", EN: "Team member" },
  followupTitle: { FR: "Ensuite", EN: "Then" },
  followupNone: { FR: "Rien", EN: "Nothing" },
  followupTask: { FR: "Créer une tâche", EN: "Create a task" },
  followupPlaybook: { FR: "Lancer un playbook", EN: "Launch a playbook" },
  followupDueFromField: {
    FR: "La date du champ « {field} »",
    EN: "The \u201c{field}\u201d date",
  },
  followupDueDelay: { FR: "Échéance dans (jours)", EN: "Due in (days)" },
  followupDueDefault: {
    FR: "Délai du type de tâche",
    EN: "The task type's delay",
  },
  category: { FR: "Catégorie", EN: "Category" },
  categoryCall: { FR: "Appel", EN: "Call" },
  categoryMeeting: { FR: "Rendez-vous", EN: "Meeting" },
  categoryEmail: { FR: "Email", EN: "Email" },
  categoryLinkedin: { FR: "LinkedIn", EN: "LinkedIn" },
  categoryNote: { FR: "Note", EN: "Note" },
  categoryDeal: { FR: "Commercial", EN: "Deal" },
  categoryProduct: { FR: "Produit", EN: "Product" },
  categoryOther: { FR: "Autre", EN: "Other" },
  newActivityType: { FR: "Nouveau type d'activité", EN: "New activity type" },
  editActivityType: {
    FR: "Modifier le type d'activité",
    EN: "Edit activity type",
  },
  newTaskType: { FR: "Nouveau type de tâche", EN: "New task type" },
  newPlaybook: { FR: "Nouveau playbook", EN: "New playbook" },
  editPlaybook: { FR: "Modifier le playbook", EN: "Edit playbook" },
  playbookDescription: { FR: "Description", EN: "Description" },
  newRule: { FR: "Nouvelle règle", EN: "New rule" },
  editRule: { FR: "Modifier la règle", EN: "Edit rule" },
  ruleName: { FR: "Nom", EN: "Name" },
  ruleActive: { FR: "Active", EN: "Active" },
  ruleInactive: { FR: "Désactivée", EN: "Off" },
  ruleAppliesTo: { FR: "S'applique à", EN: "Applies to" },
  appliesAny: { FR: "Tout le travail", EN: "All work" },
  appliesCrm: { FR: "Tâches CRM", EN: "CRM tasks" },
  appliesStep: { FR: "Étapes de séquence", EN: "Sequence steps" },
  appliesNote: { FR: "Rappels de campagne", EN: "Campaign reminders" },
  ruleTaskType: { FR: "Type de tâche", EN: "Task type" },
  anyTaskType: { FR: "Tous les types", EN: "Every type" },
  ruleStepType: { FR: "Type d'étape", EN: "Step type" },
  anyStepType: { FR: "Toutes les étapes", EN: "Every step" },
  ruleCampaign: { FR: "Campagne", EN: "Campaign" },
  anyCampaign: { FR: "Toutes les campagnes", EN: "Every campaign" },
  ruleStrategy: { FR: "Répartition", EN: "Strategy" },
  strategyRoundRobin: { FR: "À tour de rôle", EN: "Round robin" },
  strategyFixed: {
    FR: "Toujours la même personne",
    EN: "Always the same person",
  },
  ruleMembers: { FR: "Membres", EN: "Members" },
  ruleMembersPick: { FR: "Choisir des membres", EN: "Pick members" },
  ruleOverridesOwner: {
    FR: "Prioritaire sur la personne assignée à l'entreprise",
    EN: "Takes precedence over whoever the company is assigned to",
  },
  ruleNoMembers: {
    FR: "Choisissez au moins un membre.",
    EN: "Pick at least one member.",
  },
  ruleNextUp: { FR: "Prochain : {name}", EN: "Next up: {name}" },
  ruleSummaryRoundRobin: {
    FR: "{members} à tour de rôle",
    EN: "{members}, in turn",
  },
  ruleSummaryFixed: { FR: "Toujours {member}", EN: "Always {member}" },
  rulesEmpty: {
    FR: "Aucune règle : le travail sans responsable reste dans « Non assignées ».",
    EN: "No rule: work nobody owns stays under “Unassigned”.",
  },
  nameRequired: { FR: "Un nom est requis.", EN: "A name is required." },
  stepsRequired: {
    FR: "Ajoutez au moins une étape.",
    EN: "Add at least one step.",
  },
  openInstagramAccount: {
    FR: "Ouvrir le compte Instagram",
    EN: "Open the Instagram account",
  },
  openWhatsappChat: {
    FR: "Ouvrir la conversation WhatsApp",
    EN: "Open the WhatsApp chat",
  },
  // --- revenue ------------------------------------------------------------
  tabRevenue: { FR: "Revenus", EN: "Revenue" },
  revenueClient: { FR: "Revenu client", EN: "Client revenue" },
  revenuePipeline: { FR: "Pipeline estimé", EN: "Estimated pipeline" },
  revenueLost: { FR: "Valeur perdue", EN: "Lost value" },
  revenueClientHint: {
    FR: "L'entreprise est cliente : ces montants sont du revenu réel.",
    EN: "This company is a client: these amounts are real revenue.",
  },
  revenuePipelineHint: {
    FR: "Estimation tant que l'entreprise n'est pas cliente. Elle devient du revenu réel dès qu'un lead est marqué client.",
    EN: "An estimate until the company becomes a client. It turns into real revenue as soon as a lead is marked as client.",
  },
  revenueLostHint: {
    FR: "L'entreprise est perdue : ces montants ne comptent plus dans les totaux.",
    EN: "This company is lost: these amounts no longer count in the totals.",
  },
  revenueMonthly: { FR: "Mensuel", EN: "Monthly" },
  revenueAnnual: { FR: "Annuel", EN: "Annual" },
  revenueOneShot: { FR: "One-shot", EN: "One-off" },
  revenueEmpty: {
    FR: "Aucun montant pour l'instant. Ajoutez ce que cette entreprise peut vous rapporter : abonnement, frais uniques ou facturation à l'usage.",
    EN: "No amount yet. Add what this company can bring in: a subscription, a one-off fee or usage-based billing.",
  },
  addRevenueLine: { FR: "Ajouter un montant", EN: "Add an amount" },
  editRevenueLine: { FR: "Modifier le montant", EN: "Edit the amount" },
  deleteRevenueLine: { FR: "Supprimer", EN: "Delete" },
  revenueLineActions: { FR: "Actions sur le montant", EN: "Amount actions" },
  revenueLineCreatedToast: { FR: "Montant ajouté", EN: "Amount added" },
  revenueLineUpdatedToast: { FR: "Montant modifié", EN: "Amount updated" },
  revenueLineDeletedToast: { FR: "Montant supprimé", EN: "Amount deleted" },
  billingType: { FR: "Facturation", EN: "Billing" },
  billing_one_shot: { FR: "One-shot", EN: "One-off" },
  billing_recurring: { FR: "Récurrente", EN: "Recurring" },
  billing_variable: { FR: "Variable", EN: "Usage-based" },
  billing_one_shot_hint: {
    FR: "Facturé une seule fois : frais de mise en place, projet, licence.",
    EN: "Billed once: setup fee, project, licence.",
  },
  billing_recurring_hint: {
    FR: "Le même montant à chaque période : abonnement, forfait.",
    EN: "The same amount every period: subscription, retainer.",
  },
  billing_variable_hint: {
    FR: "Un prix unitaire multiplié par une quantité estimée à chaque période.",
    EN: "A unit price times an estimated quantity every period.",
  },
  billingPeriod: { FR: "Période", EN: "Period" },
  period_month: { FR: "Mensuelle", EN: "Monthly" },
  period_quarter: { FR: "Trimestrielle", EN: "Quarterly" },
  period_year: { FR: "Annuelle", EN: "Yearly" },
  per_month: { FR: "/ mois", EN: "/ month" },
  per_quarter: { FR: "/ trimestre", EN: "/ quarter" },
  per_year: { FR: "/ an", EN: "/ year" },
  revenueLabel: { FR: "Libellé", EN: "Label" },
  revenueLabelPlaceholder: {
    FR: "Abonnement Pro, frais de setup…",
    EN: "Pro plan, setup fee…",
  },
  amountTotal: { FR: "Montant (€ HT)", EN: "Amount (€ excl. VAT)" },
  amountPerPeriod: {
    FR: "Montant par période (€ HT)",
    EN: "Amount per period (€ excl. VAT)",
  },
  unitPrice: { FR: "Prix unitaire (€ HT)", EN: "Unit price (€ excl. VAT)" },
  quantityPerPeriod: {
    FR: "Quantité estimée par période",
    EN: "Estimated quantity per period",
  },
  unitLabel: { FR: "Unité", EN: "Unit" },
  unitLabelPlaceholder: {
    FR: "leads, heures, licences…",
    EN: "leads, hours, seats…",
  },
  startsOn: { FR: "Début", EN: "Start" },
  endsOn: { FR: "Fin", EN: "End" },
  endsOnHint: {
    FR: "Une ligne terminée ne compte plus dans le mensuel.",
    EN: "A line that ended no longer counts in the monthly figure.",
  },
  noDate: { FR: "Aucune date", EN: "No date" },
  clearDate: { FR: "Effacer", EN: "Clear" },
  revenueNote: { FR: "Note", EN: "Note" },
  monthlyEquivalent: { FR: "≈ {amount} / mois", EN: "≈ {amount} / month" },
  unitsTimes: {
    FR: "{quantity} {unit} × {price}",
    EN: "{quantity} {unit} × {price}",
  },
  unitsDefault: { FR: "unités", EN: "units" },
  revenueEnded: { FR: "Terminé", EN: "Ended" },
  invalidAmount: {
    FR: "Saisissez un montant supérieur à 0.",
    EN: "Enter an amount above 0.",
  },
  amountTooLarge: {
    FR: "Ce montant est trop élevé.",
    EN: "This amount is too large.",
  },
  quantityRequired: {
    FR: "Saisissez une quantité estimée.",
    EN: "Enter an estimated quantity.",
  },
  endBeforeStart: {
    FR: "La fin doit être après le début.",
    EN: "The end must be after the start.",
  },
  revenueColumn: { FR: "Valeur", EN: "Value" },
  // --- product catalog ----------------------------------------------------
  settingsProducts: { FR: "Produits et tarifs", EN: "Products and pricing" },
  settingsProductsHint: {
    FR: "Ce que vous vendez et à quel prix. Un montant ajouté sur une entreprise part de l'un d'eux, puis reste modifiable.",
    EN: "What you sell and at what price. An amount added on a company starts from one of them, then stays editable.",
  },
  noProducts: {
    FR: "Aucun produit pour l'instant. Ajoutez un abonnement, des frais de setup ou un tarif à l'usage.",
    EN: "No product yet. Add a subscription, a setup fee or a usage-based price.",
  },
  newProduct: { FR: "Nouveau produit", EN: "New product" },
  editProduct: { FR: "Modifier le produit", EN: "Edit product" },
  productName: { FR: "Nom", EN: "Name" },
  productNamePlaceholder: {
    FR: "Abonnement Pro, frais de setup…",
    EN: "Pro subscription, setup fee…",
  },
  linkedProduct: { FR: "Offre liée", EN: "Linked offer" },
  linkedProductNone: { FR: "Aucune", EN: "None" },
  linkedProductHint: {
    FR: "L'offre de vos campagnes à laquelle ce tarif appartient.",
    EN: "The campaign offer this price belongs to.",
  },
  pricePerUnit: { FR: "{price} / {unit}", EN: "{price} / {unit}" },
  fromCatalog: { FR: "Produit", EN: "Product" },
  customLine: { FR: "Sur mesure", EN: "Custom" },
  fromCatalogHint: {
    FR: "Pré-remplit le montant, qui reste modifiable pour cette entreprise.",
    EN: "Prefills the amount, which stays editable for this company.",
  },
} satisfies FullTranslation
